export const MODULE_NAME = 'Patients'
export const MMN = 'Meritage Medical Network'
export const FCMG = 'First Choice Medical Group'

export enum LineOfBusiness {
  MMN = 1,
  FCMG = 2
}